<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <form v-if="type === '1'">
      <div class="form-line">
        <div class="line-text">姓名：</div>
        <div>{{formData1.name || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">性别：</div>
        <div>{{formData1.sex || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">职工号：</div>
        <div>{{formData1.workCode || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">民族：</div>
        <div>{{formData1.nationName || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">出生年月：</div>
        <div>{{formData1.birthday || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">身份证号：</div>
        <div>{{formData1.identityNumber || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">联系电话：</div>
        <div>{{formData1.phone || '无'}}</div>
      </div>
    </form>
    <form v-if="type === '2'">
      <div class="form-line">
        <div class="line-text">住户名称：</div>
        <div>{{formData2.enterpriseName || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">住户联系人姓名：</div>
        <div>{{formData2.enterpriseManagerName || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">住户联系人性别：</div>
        <div>{{formData2.enterpriseManagerSex || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">住户联系人职位：</div>
        <div>{{formData2.enterprisePosition || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">住户联系人手机号码：</div>
        <div>{{formData2.enterpriseManagerPhone || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">住户联系人邮箱：</div>
        <div>{{formData2.enterpriseManagerEmail || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">住户简介：</div>
        <div>{{formData2.enterpriseIntroduction || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">住户资质文件：</div>
        <div>{{formData2.enterpriseQualification || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">租赁时间：</div>
        <div>{{formData2.centStartTime}} 至 {{formData2.centEndTime}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">房间号：</div>
        <div>{{formData2.roomNumber || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">租赁状态：</div>
        <div>{{formData2.rentStatus || '无'}}</div>
      </div>
    </form>
    <div class="form-btn-box">
      <button-confirm @confirm="confirm" value="通过" />
      <button-delete-data @deleteData="cancel" value="驳回" />
      <button-cancel @cancel="cancelApply" value="返回" />
    </div>
  </div>
</template>

<script>
  import Breadcrumb from '../../components/Breadcrumb/Breadcrumb'
  import {api} from '../api/User'
  import {errorHandler} from '../../utils/errorHandler'
  import ButtonConfirm from '../../components/Button/ButtonConfirm'
  import {nSuccess} from '../../utils/notice'
  import ButtonDeleteData from '../../components/Button/ButtonDelete'
  import ButtonCancel from '../../components/Button/ButtonCancel'

  export default {
    components: {
      ButtonCancel,
      ButtonDeleteData,
      ButtonConfirm,
      Breadcrumb},
    name: 'approval-details',
    data () {
      return {
        breadcrumb: [{
          value: '用户中心',
          name: 'account-management'
        }, {
          value: '审批详情'
        }],
        type: '',
        currentCode: '',
        formData1: {},
        formData2: {}
      }
    },
    created () {
      this.currentCode = this.$route.params.id
      this.type = this.$route.params.type
      this.getBaklogByCode()
    },
    methods: {
      toNeedHandlePage () {
        this.$router.push({
          name: 'need-handle'
        })
      },
      getBaklogByCode () {
        this.$axios.get(`${api.getBaklogByCode}/${this.currentCode}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              if (this.type === '2') {
                if (data.enterpriseManagerSex === '1') {
                  data.enterpriseManagerSex = '男'
                } else if (data.enterpriseManagerSex === '0') {
                  data.enterpriseManagerSex = '女'
                }
                if (data.rentStatus === '0') {
                  data.rentStatus = '空置'
                } else if (data.rentStatus === '1') {
                  data.rentStatus = '在租'
                } else if (data.rentStatus === '2') {
                  data.rentStatus = '临近租期'
                }
                this.formData2 = data
              } else if (this.type === '1') {
                if (data.sex === '1') {
                  data.sex = '男'
                } else if (data.sex === '0') {
                  data.sex = '女'
                }
                this.formData1 = data
              }
            }
          })
          .catch(errorHandler('获取审批信息失败'))
      },
      confirm () {
        if (this.type === '1') {
          this.$axios.post(api.approvePersonBaklog, {
            baklogCode: this.currentCode
          })
            .then(res => {
              if (res.data.retCode === 1) {
                nSuccess('审批通过')
                this.toNeedHandlePage()
              }
            })
            .catch(errorHandler('审批失败'))
        } else if (this.type === '2') {
          this.$axios.post(`${api.approveBaklogByCode}/${this.currentCode}`, {})
            .then(res => {
              if (res.data.retCode === 1) {
                nSuccess('审批通过')
                this.toNeedHandlePage()
              }
            })
            .catch(errorHandler('审批失败'))
        }
      },
      cancel () {
        this.$axios.post(`${api.unApproveBaklogByCode}/${this.currentCode}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('驳回成功')
              this.toNeedHandlePage()
            }
          })
          .catch(errorHandler('驳回失败'))
      },
      cancelApply () {
        this.toNeedHandlePage()
      }
    }
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: center;
  }
  .form-line div {
    width: 300px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
    width: 200px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin: 40px auto 0;
    display: flex;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/view/User/ApprovalDetails.vue